function printBtn() {
  $('.print__cta .btn').on('click', function(e) {
    e.preventDefault()
    window.print();
  })
}

export default printBtn();



// WEBPACK FOOTER //
// ../markup/assets/js/print-btn.js